import React from "react";
import styled from "styled-components";
import { Database } from "../../database.types";
import { Button } from "../common/Button";

type News = Database["public"]["Tables"]["news"]["Row"];

type NewsCardProps = {
  news: News;
};

const Card = styled.article`
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  background: #f0f0f0;

  @media (min-width: 768px) {
    height: 450px;
  }

  @media (min-width: 1024px) {
    height: 500px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Content = styled.div`
  padding: 32px;

  @media (min-width: 768px) {
    padding: 40px;
  }
`;

const Title = styled.h3`
  font-family: "Open Sans", sans-serif;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: #333;
  line-height: 1.4;
  text-transform: uppercase;

  @media (min-width: 768px) {
    font-size: 26px;
    margin: 0 0 20px 0;
  }
`;

const Subtitle = styled.p`
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #666;
  opacity: 0.7;
  margin: 0 0 20px 0;
  line-height: 1.6;
  text-transform: uppercase;

  @media (min-width: 768px) {
    font-size: 18px;
    margin: 0 0 24px 0;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 20px;

  button {
    padding: 16px 32px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

export const NewsCard: React.FC<NewsCardProps> = ({ news }) => {
  return (
    <Card>
      {news.image_url && (
        <ImageContainer
          onClick={() => {
            if (news.button_url) window.open(news.button_url, "_blank");
          }}
          style={{ cursor: "pointer" }}
        >
          <Image src={news.image_url} alt={news.title} loading="lazy" />
        </ImageContainer>
      )}
      <Content>
        <Title>{news.title}</Title>
        {news.subtitle && <Subtitle>{news.subtitle}</Subtitle>}
        {news.button_title && news.button_url && (
          <ButtonContainer>
            <Button
              variant="primary"
              fullWidth
              onClick={() => {
                if (news.button_url) window.open(news.button_url, "_blank");
              }}
            >
              {news.button_title}
            </Button>
          </ButtonContainer>
        )}
      </Content>
    </Card>
  );
};
